import script from "./WaveExpenses.vue?vue&type=script&setup=true&lang=js"
export * from "./WaveExpenses.vue?vue&type=script&setup=true&lang=js"

import "./WaveExpenses.vue?vue&type=style&index=0&id=2d3e3954&scoped=true&lang=css"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d3e3954"]])

export default __exports__